import * as Yup from 'yup';
import { IValidation } from '../../models/components/validation-props';
import { DefaultValidation } from './main-validations';

export function getValidation(props?: IValidation) {
    
    const defaultValidation = new DefaultValidation(props);

    if(props && props.isProjectSubActivity) {
        return Yup.object().shape({ name: defaultValidation.GetName() });
    }    
    return Yup.object().shape({
        defaultValuesFormik: defaultValidation.SetDefaultValues(),
        isFileUploadEmpty: defaultValidation.GetIsFileUploadEmpty(),
        name: defaultValidation.GetName(),
        activityBeginDate: defaultValidation.GetActivityBeginDate(),
        activityBeginTime: defaultValidation.GetActivityBeginTime(),
        activityEndDate: defaultValidation.GetActivityEndDate(),
        activityEndTime: defaultValidation.GetActivityEndTime(),
        datePrerequisiteActivityId: defaultValidation.GetDatePrerequisiteActivityId(),
        selectActivity: defaultValidation.GetSelectActivity(),
        grade: defaultValidation.GetGrade(),
        isCommon: defaultValidation.GetIsCommon(),
        selectedClass: defaultValidation.GetSelectedClass(),
        activityTime: defaultValidation.GetActivityTime(),
        completionType: defaultValidation.GetCompletionType(),
        completionCriteria: defaultValidation.GetCompletionCriteria(),
        prerequisiteActivityId: defaultValidation.GetPrerequisiteActivityId(),
    });
}
